"use client"

import { useState, useEffect, useRef } from "react"
import trustpilotLogo from "../../assets/images/trustpilot-logo.png"
import googleLogo from "../../assets/images/Google-Review-Logo.png"
import gLogo from "../../assets/images/googleg_48dp.png"
import styles from "./Reviews.module.css"
import { supabase } from "../../lib/supabaseClient"

export default function Reviews() {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [visibleCount, setVisibleCount] = useState(2)

  // Responsive visible count
  useEffect(() => {
    const updateVisibleCount = () => {
      if (window.innerWidth <= 480) {
        setVisibleCount(1)
      } else if (window.innerWidth <= 768) {
        setVisibleCount(1)
      } else if (window.innerWidth <= 1024) {
        setVisibleCount(1.5)
      } else {
        setVisibleCount(2)
      }
    }

    updateVisibleCount()
    window.addEventListener("resize", updateVisibleCount)
    return () => window.removeEventListener("resize", updateVisibleCount)
  }, [])
  const [isDragging, setIsDragging] = useState(false)
  const [isAnimating, setIsAnimating] = useState(false)
  const [dragX, setDragX] = useState(0)
  const [offsetX, setOffsetX] = useState(0)
  const dragStartXRef = useRef(0)
  const trackRef = useRef(null)
  const containerRef = useRef(null)
  const [tileWidth, setTileWidth] = useState(0)
  const [userCards, setUserCards] = useState([])
  const GAP = 24
  const baseCards = [
    {
      name: "miray sude",
      country: "",
      text: "The employees are friendly, the service is good, the clinic is clean, I would like to thank the entire Estaverde clinic team.",
    },
    {
      name: "Nilay",
      country: "",
      text: "У меня начали выпадать волосы на лбу, и примерно через 6 месяцев с техниками клиники EstaVerde я избавился от облысения. Спасибо всей команде!",
    },
    {
      name: "Анастасия Яковенко",
      country: "",
      text: "Хочу выразить благодарность за высокое качество организации моей пересадки волос. Моего мужа сопровождали на каждом этапе — от первичной консультации до последующих осмотров. Все прошло чётко, вовремя и без стресса: трансферы, клиника, переводчик, рекомендации — всё было продумано. Результатом и отношением команды осталась очень довольны. Могу уверенно рекомендовать!",
    },
    { name: "ozden aktuz", 
      country: "", 
      text: "I had some doubts about getting a hair transplant, but this clinic completely changed my mind. Everyone was so caring and made me feel comfortable throughout the process. The procedure was much easier than I expected. Now every time I look in the mirror, I’m glad I did it. Thanks to the whole team!" 
    },
    {
      name: "Onur",
      country: "",
      text: "As someone who has experienced hair transplantation, they really have a quality environment, they are very clean and hygienic, thank you to the whole Estaverde team.",
    },
    { name: "Drift", 
      country: "", 
      text: "Очень доволен пересадкой волос в EstaVerde. Врачи аккуратные, персонал дружелюбный, организация на высшем уровне — трансфер, отель, всё идеально. Видно, что работают профессионалы." 
    },
    { name: "Hüseyn Veliyev",
      country: "",
      text: "Спасибо клинике EstaVerde за профессиональный подход! Операция прошла без боли, уход после процедуры был очень удобный. Чувствую себя уверенно как никогда. Лучшее решение!"
    },
    { name: "Mehtap Perktaş",
      country: "",
      text: "I had breathing difficulties in my nose. When I saw the Estaverde clinic, I was hesitant at first because I thought it would be like other clinics, but I am very pleased with my new nose. We finished without any problems."
    }
  ]
  const cards = [...baseCards, ...userCards]

  // Fetch existing approved comments from Supabase
  useEffect(() => {
    let mounted = true
    const fetchComments = async () => {
      try {
        const { data, error } = await supabase
          .from('review_comments')
          .select('name, country, comment, created_at')
          .eq('approved', true)
          .order('created_at', { ascending: false })
        if (error) throw error
        if (!mounted) return
        const mapped = (data || []).map(r => ({ name: r.name, country: r.country, text: r.comment }))
        setUserCards(mapped)
      } catch (err) {
        console.error('Failed to fetch comments:', err)
      }
    }
    fetchComments()
    return () => { mounted = false }
  }, [])

  // compute tile width based on container
  useEffect(() => {
    const calc = () => {
      const el = containerRef.current
      if (!el) return
      const w = el.getBoundingClientRect().width
      const per = (w - (visibleCount - 1) * GAP) / visibleCount
      setTileWidth(per)
    }
    calc()
    window.addEventListener("resize", calc)
    return () => window.removeEventListener("resize", calc)
  }, [visibleCount])

  // drag handlers
  useEffect(() => {
    if (!isDragging) return
    const onMove = (e) => {
      const clientX = e.clientX ?? (e.touches && e.touches[0] && e.touches[0].clientX)
      if (clientX == null) return
      setDragX(clientX - dragStartXRef.current)
    }
    const onUp = () => {
      const threshold = 50
      const track = trackRef.current
      if (!track) return
      if (dragX <= -threshold) {
        setIsAnimating(true)
        track.style.transition = "transform 300ms ease"
        setOffsetX(-(tileWidth + GAP))
        const onEnd = () => {
          track.style.transition = "none"
          setCurrentIndex((p) => (p + 1) % cards.length)
          setOffsetX(0)
          setIsAnimating(false)
          track.removeEventListener("transitionend", onEnd)
        }
        track.addEventListener("transitionend", onEnd)
      } else if (dragX >= threshold) {
        setIsAnimating(true)
        track.style.transition = "transform 300ms ease"
        setOffsetX(tileWidth + GAP)
        const onEnd = () => {
          track.style.transition = "none"
          setCurrentIndex((p) => (p - 1 + cards.length) % cards.length)
          setOffsetX(0)
          setIsAnimating(false)
          track.removeEventListener("transitionend", onEnd)
        }
        track.addEventListener("transitionend", onEnd)
      }
      setIsDragging(false)
      setDragX(0)
    }
    window.addEventListener("pointermove", onMove)
    window.addEventListener("pointerup", onUp)
    window.addEventListener("touchmove", onMove, { passive: true })
    window.addEventListener("touchend", onUp)
    return () => {
      window.removeEventListener("pointermove", onMove)
      window.removeEventListener("pointerup", onUp)
      window.removeEventListener("touchmove", onMove)
      window.removeEventListener("touchend", onUp)
    }
  }, [isDragging, dragX, tileWidth])
  return (
    <section className="section white">
      <div className="container">
        <div className={styles.headerContainer}>
          <a href="https://share.google/b9TMnlh7srexgX7sv" target="_blank" rel="noopener noreferrer">
            <h2 className={styles.title}><span className={styles.titleBlue}> Real Stories, Real Results, </span><br /><span className={styles.titleGreen}>Real Hapiness</span></h2>
          </a>
          <div className={styles.ratingsRow}>
            <div className={styles.ratingBlock}>
              <a href="https://share.google/b9TMnlh7srexgX7sv" target="_blank" rel="noopener noreferrer"><img src={googleLogo} alt="Google Reviews" className={styles.ratingLogoGoogle} /></a>
              <a href="https://share.google/b9TMnlh7srexgX7sv" target="_blank" rel="noopener noreferrer"><div className={styles.scoreGoogle}>4.9</div></a>
            </div>
          </div>
        </div>
        <div className={styles.sliderWrapper}>
          <div
            ref={containerRef}
            className={`${styles.sliderContent} ${styles[`sliderContent-${visibleCount}`]}`}
            onPointerDown={(e) => {
              if (isAnimating) return
              setIsDragging(true)
              setDragX(0)
              dragStartXRef.current = e.clientX ?? (e.touches && e.touches[0] && e.touches[0].clientX) ?? 0
            }}
            style={{ cursor: isDragging ? "grabbing" : "grab" }}
          >
            <div
              ref={trackRef}
              className={styles.sliderTrack}
              style={{ transform: `translateX(${(-(tileWidth + GAP)) + offsetX + dragX}px)` }}
            >
              {(() => {
                const len = cards.length
                const prevIdx = (currentIndex - 1 + len) % len
                const visibleCountInt = Math.ceil(visibleCount)
                const arr = [cards[prevIdx], ...Array.from({ length: visibleCountInt }, (_, i) => cards[(currentIndex + i) % len]), cards[(currentIndex + visibleCountInt) % len]]
                return arr.map((c, i) => {
                  if (!c) return null
                  const initials = c.name.split(" ").map(p => p[0]).slice(0,2).join("").toUpperCase()
                  return (
                    <div key={`${currentIndex}-${i}`} className={styles.sliderTile} style={{ width: tileWidth ? `${tileWidth}px` : `calc((100% - ${(visibleCount - 1) * GAP}px) / ${visibleCount})` }}>
                      <article className={styles.reviewCard}>
                        <header className={styles.reviewHeader}>
                          <div className={styles.avatarSection}>
                            <div className={styles.avatar} aria-hidden="true">{initials}</div>
                            <div className={styles.nameBlock}>
                              <div className={styles.name}>{c.name}</div>
                              <div className={styles.googleInfo}>
                                <img src={gLogo} alt="Google" className={styles.googleIcon} />
                                <span className={styles.googleTextGoogle}>Google</span>
                                <span className={styles.googleTextRev}>reviews</span>
                              </div>
                            </div>
                          </div>
                          <div className={styles.googleBadge}>Google</div>
                        </header>
                        <div className={styles.rating}>5/5 · </div>
                        <p className={styles.reviewText}>{c.text}</p>
                      </article>
                    </div>
                  )
                }).filter(Boolean)
              })()}
            </div>
          </div>
        </div>
        <div className={styles.dots}>
          {cards.map((_, i) => (
            <button
              key={i}
              className={`${styles.dot} ${i === currentIndex ? styles.dotActive : ""}`}
              aria-label={`Go to review ${i + 1}`}
              onClick={() => setCurrentIndex(i)}
            />
          ))}
        </div>

        {/* Comment form removed as requested */}
      </div>
    </section>
  )
}
